import { useEffect, useRef, useState, type RefObject } from 'react';
import type { SubmitOutcome } from './useInvoiceSubmission';

const FIRST_ERROR_SELECTOR = [
    '[data-rejection-target]',
    '#invoice-number[aria-invalid="true"]',
    '#invoiced-at[aria-invalid="true"]',
    '#invoicing-dealer[aria-invalid="true"]',
    '#funding-approval-code[aria-invalid="true"]',
].join(', ');

export interface RejectionFocus {
    panelRef: RefObject<HTMLElement | null>;
    onSettled: (outcome: SubmitOutcome) => void;
}

/** A failed submit only records a request; the focus move runs after the messages commit. */
export function useRejectionFocus(): RejectionFocus {
    const panelRef = useRef<HTMLElement | null>(null);
    const [requests, setRequests] = useState(0);

    useEffect(() => {
        if (requests === 0) return;
        panelRef.current?.querySelector<HTMLElement>(FIRST_ERROR_SELECTOR)?.focus();
    }, [requests]);

    return {
        panelRef,
        onSettled: (outcome) => {
            if (!outcome.ok) setRequests((count) => count + 1);
        },
    };
}
